import React, { useCallback, useEffect, useRef, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import categoryAPI from "../../api/categoryApi";
import CategoryCard from "../categories/Card";
import Card from "../categories/Card";

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const observer = useRef();

  useEffect(() => {
    fetchCategories(page);
  }, [page]);

  const fetchCategories = async (currentPage) => {
    setLoading(true);

    try {
      const res = await categoryAPI.listing({ page: currentPage });

      if (res.code === 200) {
        const { items, pagination } = res.data;

        setItems((prev) =>
          currentPage === 1 ? items || [] : [...prev, ...(items || [])],
        );
        setTotalCount(pagination?.totalCount || 0);
      }
    } catch (err) {
      console.error("Error loading categories:", err);
    } finally {
      setLoading(false);
    }
  };

  const lastItemRef = useCallback(
    (node) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && items.length < totalCount) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, items, totalCount],
  );

  return (
    <>
      <Breadcrump title="Category" />

      
      <section className="luxury-cats-section">
      <div className="container-fluid px-3 px-lg-5">
        
        {/* Header */}
        <div className="section-header-luxury">
          <div>
            <span className="text-uppercase fw-semibold" style={{fontSize: '11px', letterSpacing: '1.5px', color: 'var(--luxury-gold)'}}>
              Curated Collections
            </span>
            <h2 className="section-title-luxury">Our Categories</h2>
          </div>
        </div>

        {/* Dynamic Grid */}
        <div className="row g-4">
          {items.map((item, index) => (
            <div 
              key={item._id} 
              className="col-12 col-sm-6 col-md-4 col-xl-2"
              ref={index === items.length - 1 ? lastItemRef : null}
            >
              <Card item={item} />
            </div>
          ))}
        </div>

          {loading && (
            <div className="text-center mt-4">
              <p>Loading more products...</p>
            </div>
          )}

          {/* End Message */}
          {!loading && items.length >= totalCount && (
            <div className="text-center mt-4">
              <p>✨ You’ve reached the end</p>
            </div>
          )}
      </div>
    </section>
    </>
  );
}

export default ListPage;
